import { FC } from "react";
import { COLORS } from "shared/consts";

type AddLargeProps = {
  fill?: string;
}

export const AddLarge: FC<AddLargeProps> = ({
  fill=COLORS.STATIC.WHITE
}) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" width="20.000000" height="20.000000" fill="none">
      <path id="Union" d="M9.375 10.625L9.375 17.5L10.625 17.5L10.625 10.625L17.5 10.625L17.5 9.375L10.625 9.375L10.625 2.5L9.375 2.5L9.375 9.375L2.5 9.375L2.5 10.625L9.375 10.625Z" fill={fill} fillRule="evenodd"/>
    </svg>
  )
}

